var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-sales"),
      _vm._v(" "),
      _c("div", { attrs: { id: "subheader" } }),
      _vm._v(" "),
      _c("div", { attrs: { id: "main-container" } }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { attrs: { id: "container" } }, [
          _c("div", { attrs: { id: "header-pedido" } }, [
            _c("div", { attrs: { id: "header-pedidoL" } }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "label-total"
                },
                [_vm._v("Pedido  ")]
              ),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                staticClass: "menu",
                attrs: { id: "icon", src: "/dist/icon-editar.png" }
              })
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "label-total" }, [
                _vm._v(
                  "Subtotal: $ " +
                    _vm._s(_vm._f("formatMoney")(_vm.subtotal)) +
                    " "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "label-total" }, [
                _vm._v(
                  "Total: $ " + _vm._s(_vm._f("formatMoney")(_vm.total)) + " "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "list-container" } },
            _vm._l(_vm.productos, function(item) {
              return _c("item-pedido", {
                attrs: { id: "list-prod", item: item }
              })
            })
          ),
          _vm._v(" "),
          _c("div", { attrs: { id: "btnContainer" } }, [
            _c("input", {
              attrs: {
                id: "btnReplicar",
                type: "submit",
                value: "REPLICAR  PEDIDO"
              },
              on: { click: _vm.btnReplicar }
            })
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "label-container" } }, [
      _c("span", { attrs: { id: "label" } }, [_vm._v("Ver Pedido")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66eee411", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66eee411","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/estadoPedido/pedidoCms.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-66eee411","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/estadoPedido/pedidoCms.vue
// module chunks = 0